<template>
	<div class="plr-16 pt-20">
		 <div v-html="content"></div>
		 <loading :loadFlag="loadFlag"></loading>
	</div>

</template>
<script>
	import loading from "@/components/loading"
  import { messageDetails } from '@/api/api.js'
	export default {
		components: {
      loading
		},
		data() {
			return {
			  content: '',
				loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		methods: {
			async initData(){
				this.loadFlag = true
				const res = await messageDetails({ mid: this.$route.query.id })
				this.loadFlag = false
				if(res.code == 1000){
          this.content = res.data.content
				} else {
            this.$toast(res.msg)
          }
				
			}
		}
	}
</script>
<style lang="less" scoped>

</style>
